<template>
  <div class="metafield-edit-number">
    <BaseInput
      :data-vv-as="field.type"
      :name="$attrs.name"
      :value="value"
      :label="field.label"
      type="text"
      :hint="hint"
      @input="onInput"
      :validate="validator()"
      :minVal="+this.subFormData.min || -Infinity"
      :maxVal="+this.subFormData.max || Infinity"
      ></BaseInput>
  </div>
</template>

<script>
import { forSingleMetafield } from '@/mixins/metafields-changed-detection.mixin'

export default {
  inject: ['$validator'],
  mixins: [ forSingleMetafield(true) ],
  props: {
    field: Object,
    value: [String, Number],
    subFormData: Object,
    hint: String
  },
  methods: {
    onInput (val) {
      this.$emit('input', val === '' ? null : val)
    },
    validator () {
      return `decimal|min_value:${+this.subFormData.min || -Infinity}|max_value:${+this.subFormData.max || Infinity}`
    }
  },
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/metafields-edit/metafields/MetafieldEditNumber.vue